import { auth } from "./firebase";

export class ApiError extends Error {
  status: number;
  payload: unknown;
  constructor(message: string, status: number, payload: unknown) {
    super(message);
    this.status = status;
    this.payload = payload;
  }
}

export async function callFunction<TResponse, TBody>(
  url: string,
  body: TBody,
): Promise<TResponse> {
  const user = auth.currentUser;
  if (!user) throw new Error("Not signed in");
  const token = await user.getIdToken();

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });

  const data = await res
    .json()
    .catch(() => ({ error: "Invalid JSON from server" }));

  if (!res.ok) {
    const errMessage =
      typeof data === "object" && data && "error" in data
        ? String((data as { error: unknown }).error ?? "unknown")
        : "unknown";
    throw new ApiError(`Error ${res.status}: ${errMessage}`, res.status, data);
  }

  return data as TResponse;
}
